// extracted by mini-css-extract-plugin
module.exports = {"swiper_container3":"slideshow_swiper_container3__XZEEY"};